import { MENU_TYPE, DEVICE_TYPE } from "shared/components/Header/constants";

export const getAllSubcatories = (data: any) => {
    return data.children.filter(
        child =>
            child.isActive &&
            child.type === MENU_TYPE.SUBCATEGORY &&
            child.device !== DEVICE_TYPE.MOBILE
    );
};

export const getTopCategories = (data: any) =>
    data.children.find(
        child =>
            child.isActive &&
            child.type === MENU_TYPE.TOP_CATEGORIES &&
            child.device !== DEVICE_TYPE.MOBILE
    );

export const getBigImage = (data: any) =>
    data.children.find(
        child =>
            child.isActive &&
            child.type === MENU_TYPE.BIG_IMAGE &&
            child.device !== DEVICE_TYPE.MOBILE
    );
